

import ISiteDto from "./SiteDto.if";
import mappings from "./SiteDto.map";
import IMediumDto from "./MediumDto.if";
import MediumDto from "./MediumDto";
import IScreenOrientationDto from "./ScreenOrientationDto.if";
import ScreenOrientationDto from "./ScreenOrientationDto";
import IStyleDto from "./StyleDto.if";
import StyleDto from "./StyleDto";

import Transformers from './private/transformer';
import { IModelSource } from "./private/db.if";
import DBUtil from './private/db.util';
import ISiteSupportedLanguageDto from "./SiteSupportedLanguageDto.if";
import SiteSupportedLanguageDto from "./SiteSupportedLanguageDto";


function _imageLogo (this: ISiteDto, db: IModelSource): Promise<IMediumDto> {
    return DBUtil.loadMediumId<IMediumDto>(db, this.logoMediumId, MediumDto);
}

function _screenOrientation(this: ISiteDto, db: IModelSource): Promise<IScreenOrientationDto> {
    return DBUtil.loadScreenOrientationId<IScreenOrientationDto>(db, this.screenOrientationId, ScreenOrientationDto);
}

function _languageSelectionStyle(this: ISiteDto, db: IModelSource): Promise<IStyleDto> {
    return DBUtil.loadStyleId<IStyleDto>(db, this.languageSelectionStyleId, StyleDto);
}

function _tourSelectionStyle(this: ISiteDto, db: IModelSource): Promise<IStyleDto> {
    return DBUtil.loadStyleId<IStyleDto>(db, this.tourSelectionStyleId, StyleDto);
}

function _siteSupportedLanguages(this: ISiteDto, db: IModelSource): Promise<ISiteSupportedLanguageDto[]> {
    const self = this;
    return new Promise(async function(resolve, reject) {
        const ssl = await DBUtil.allSiteSupportedLanguages<ISiteSupportedLanguageDto>(db, SiteSupportedLanguageDto);
        const sslMatch = ssl.filter(x => x.siteId === self.id);
        resolve(sslMatch);
    })
}

export default (data: object) => { 
    const obj = Transformers.create<ISiteDto>(mappings, data); 

    /* addLinkables */
    obj.imageLogo = _imageLogo;
    obj.screenOrientation = _screenOrientation;
    obj.languageSelectionStyle = _languageSelectionStyle;
    obj.tourSelectionStyle = _tourSelectionStyle;

    obj.siteSupportedLanguages = _siteSupportedLanguages;

    return obj;
}

